import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

import background from './assets/background.png?file';
import WandIcon from './assets/wand.svg';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Advertising: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles({ background });
    return (
        <div className={cx(classes.container, className)}>
            <WandIcon />
            <p className={classes.title}>
                <span className={classes.accent}>{'Transform'}</span>
                {' Your Security Services'}
            </p>
            <p className={classes.description}>
                {
                    "Elevate your offerings with Vulners' advanced Vulnerability Intelligence. Contact us for a demo and discover the difference comprehensive, actionable intelligence can make in your security strategy."
                }
            </p>
            <Button variant="contained" className={classes.button} component={Link} to={'/contacts'}>
                {'Book a live demo'}
            </Button>
        </div>
    );
};

export default Advertising;
